import { t } from 'i18next';
import { versionTypeEnum } from '../enums';

export const versionTypeLabels: Record<number, string> = {
    [versionTypeEnum.MOBILE]: 'mobile',
    [versionTypeEnum.WEB]: 'web',
};

export const getVersionTypeLabel = (state?: number): string => {
    return state !== undefined && versionTypeLabels[state] ? t(versionTypeLabels[state]) : '';
};
